import {networkErrors} from '@/constants';
import {ResProtocol} from '@/core/Types/IRepository';
import routerInstance from '@/setup/router/router';

class CustomNetworkError extends Error {
  public response: ResProtocol;

  constructor(name: string, response: ResProtocol) {
    super(name);
    this.response = response;
  }
}

// tslint:disable-next-line:max-classes-per-file
export class NetworkError extends CustomNetworkError {
  constructor(response: ResProtocol) {
    super(networkErrors.network, response);
  }
}

// tslint:disable-next-line:max-classes-per-file
export class ServerError extends CustomNetworkError {
  constructor(response: ResProtocol) {
    super(networkErrors.server, response);
  }
}

// tslint:disable-next-line:max-classes-per-file
export class AuthorizationError extends CustomNetworkError {
  constructor(response: ResProtocol) {
    super(networkErrors.perms, response);
  }
}

// tslint:disable-next-line:max-classes-per-file
export class ValidationError<T extends Partial<Record<string, string[]>>> extends CustomNetworkError {
  constructor(response: ResProtocol) {
    super(networkErrors.validation, response);
  }

}

// tslint:disable-next-line:max-classes-per-file
export class AuthenticationError<T extends Partial<Record<string, string[]>>> extends CustomNetworkError {
  constructor(response: ResProtocol) {
    super(networkErrors.auth, response);
    routerInstance.replace({name: 'login', params: {e: btoa(JSON.stringify(response))}});
  }
}

// tslint:disable-next-line:max-classes-per-file
export class NotFoundError extends CustomNetworkError {
  constructor(response: ResProtocol) {
    super(networkErrors.notFound, response);
    routerInstance.replace({ name: 'subdomain-not-found' });
  }
}

// tslint:disable-next-line:max-classes-per-file
export class UnprocessableEntityError extends CustomNetworkError {
  constructor(response: ResProtocol) {
    super(networkErrors.unprocessableEntity, response);
    routerInstance.replace({ name: 'local-disabled' });
  }
}

// tslint:disable-next-line:max-classes-per-file
export class MaintenanceError extends CustomNetworkError {
  constructor(response: ResProtocol) {
    super(networkErrors.maintenance, response);
    routerInstance.replace({ name: 'Maintenance' });
  }
}
